import {
  Children,
  isValidElement,
  type FC,
  type PropsWithChildren,
  type ReactElement,
  type ReactNode,
} from 'react'

function locateChild(tag: FC<PropsWithChildren<unknown>>, children?: ReactNode) {
  let child: ReactElement | null = null
  Children.forEach(children, (c) => {
    if (isValidElement(c) && c.type === tag) {
      child = child || c
    }
  })
  return (child && ((child as ReactElement).props?.children as ReactElement)) || null
}

export default function childByTagOr(
  tag: FC<PropsWithChildren<unknown>>,
  defValue?: ReactElement | (() => ReactElement),
  children?: ReactNode,
) {
  const val = defValue || locateChild(tag, children)

  if (typeof val === 'function') {
    return val()
  }
  return val ?? null
}
